<template>
  <div>
    <action-bar>
      <button
          class="btn btn-success"
          data-toggle="modal"
          data-target="#create_field"
      >
        ایجاد فیلد
      </button>
    </action-bar>
    <div id="create_field" class="modal fade rtl" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div id="data_sheet" class="modal-body">
            <div class="modal-header">
              <h4 class="modal-title">ایجاد فیلد</h4>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <Create_field @close-modal="closeModal"/>
          </div>
        </div>
      </div>
    </div>
    <kt-datatable ref="datatable" v-bind="datatableProps"></kt-datatable>
  </div>
</template>

<script>
import {StarShopApiUrl} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from "@/views/online-factor/datatable/columns_fields";
import actionsColumn from "@/views/online-factor/components/actions_column_fields.vue";
import actionBar from "@/components/custom/action-bar.vue";
import Button from "@/components/elements/button.vue";
import CreateFieldForm from "@/views/online-factor/Create_field_form.vue";
import $ from 'jquery'

export default {
  name: "required_fields",
  components: {
    Create_field: CreateFieldForm,
    Button,
    'action-bar': actionBar,
  },
  props: {
    query: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    closeModal(){
      this.$refs.datatable.reload()
      $('#create_field').modal('hide')
    }
  },
  computed: {
    datatableProps() {
      return {
        id: 'field_datatable',
        data: {
          type: 'remote',
          source: {
            read: {
              url: StarShopApiUrl.path('customer/format/admin/field'),
              method: 'GET',
              headers: AuthorizationHeader,
              map: function(res) {
                return res.data.data;
              },
              params: this.query,
            }
          },
          pageSize: 10,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        layout: {},
        pagination: false,
        sortable: true,
        columns: columns,
        actions: actionsColumn
      };
    }
  },
}
</script>

<style scoped>

</style>